export default __webpack_public_path__ + "static/media/08.ac101e7b.png";